@file:OptIn(InternalResourceApi::class)

package asc_app.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/asc_app.composeapp.generated.resources/"

internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 48),
      ))
    }

internal val Res.string.button_text_forgot_password: StringResource by lazy {
      StringResource("string:button_text_forgot_password", "button_text_forgot_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59, 63),
      ))
    }

internal val Res.string.button_text_login: StringResource by lazy {
      StringResource("string:button_text_login", "button_text_login", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123, 33),
      ))
    }

internal val Res.string.label_mail_adresse: StringResource by lazy {
      StringResource("string:label_mail_adresse", "label_mail_adresse", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157, 46),
      ))
    }

internal val Res.string.label_password: StringResource by lazy {
      StringResource("string:label_password", "label_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204, 34),
      ))
    }

internal val Res.string.placholder_password: StringResource by lazy {
      StringResource("string:placholder_password", "placholder_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239, 47),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_name", Res.string.app_name)
  map.put("button_text_forgot_password", Res.string.button_text_forgot_password)
  map.put("button_text_login", Res.string.button_text_login)
  map.put("label_mail_adresse", Res.string.label_mail_adresse)
  map.put("label_password", Res.string.label_password)
  map.put("placholder_password", Res.string.placholder_password)
}
